<template>
  <v-layout>
    <v-card style="width: 100%;">
      <v-card-text>
        <v-container
        fluid
        grid-list-lg
        >
        <v-layout row wrap>
            <div class="scroll-here">
              <v-flex xs12>
                <strong>New Evals</strong>
              </v-flex>
              <v-flex v-for="newEval in newEvals" :key="newEval.id" xs12>
                <v-card class="elevation-4">
                  <v-card-text>
                    <v-layout wrap>
                      <v-flex xs4 md2>
                        {{ newEval.year }}
                      </v-flex>
                      <v-flex xs8 md10>
                        <strong>{{ newEval.name }}</strong>
                      </v-flex>
                      <v-flex xs4 md2></v-flex>
                      <v-flex xs8 md10>
                        <v-layout wrap>
                          <v-flex xs3>
                            Hours: {{ newEval.hours }}
                          </v-flex>
                          <v-flex xs3>
                            Award:
                            <span v-if="newEval.award === 1">
                              Yes
                            </span>
                            <span v-else>
                              No
                            </span>
                          </v-flex>
                          <v-flex xs3>
                            Drop:
                            <span v-if="newEval.drop === 1">
                              Yes
                            </span>
                            <span v-else>
                              No
                            </span>
                          </v-flex>
                          <v-flex xs3>
                            Excussed:
                            <span v-if="newEval.excussed === 1">
                              Yes
                            </span>
                            <span v-else>
                              No
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs4 md2></v-flex>
                      <v-flex xs8 md10>
                        <v-layout wrap>
                          <v-flex xs12>
                            Notes:
                          </v-flex>
                          <v-flex xs1></v-flex>
                          <v-flex xs11>
                            Award: {{ newEval.awardNotes }}
                          </v-flex>
                          <v-flex xs1></v-flex>
                          <v-flex xs11>
                            Drop: {{ newEval.dropNotes }}
                          </v-flex>
                          <v-flex xs1></v-flex>
                          <v-flex xs11>
                            Excussed: {{ newEval.exceussedNotes }}
                          </v-flex>
                          <v-flex xs1></v-flex>
                          <v-flex xs11>
                            Other: {{ newEval.notes }}
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12>
                <strong>Old Evals</strong>
              </v-flex>
              <v-flex v-for="oldEval in oldEvals" :key="oldEval.id" xs12>
                <v-card class="elevation-4">
                  <v-card-text>
                    <v-layout wrap>
                      <v-flex xs4 md2>
                        {{ oldEval.year }}
                      </v-flex>
                      <v-flex xs8 md10>
                        <strong>{{ oldEval.committee }}</strong>
                      </v-flex>
                      <v-flex xs4 md2></v-flex>
                      <v-flex xs8 md10>
                        <v-layout wrap>
                          <v-flex xs3>
                            Hours: {{ oldEval.hours }}
                          </v-flex>
                          <v-flex xs3>
                            Award:
                            <span v-if="oldEval.award === 'yes'">
                              Yes
                            </span>
                            <span v-else>
                              No
                            </span>
                          </v-flex>
                          <v-flex xs3>
                            Drop:
                            <span v-if="oldEval.drop ===  'yes'">
                              Yes
                            </span>
                            <span v-else>
                              No
                            </span>
                          </v-flex>
                          <v-flex xs3>
                            Evaluation: {{ oldEval.evaluation }}
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs4 md2></v-flex>
                      <v-flex xs8 md10>
                        <v-layout wrap>
                          <v-flex xs12>
                            Notes:
                          </v-flex>
                          <v-flex xs1></v-flex>
                          <v-flex xs11>
                            {{ oldEval.notes }}
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </div>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
export default {
  props: ['visible', 'newEvals', 'oldEvals'],

  data () {
    return {
    }
  }
}
</script>

<style>
.centered-input input {
  text-align: center;
}

.scroll-here {
  overflow: auto;
  height: 340px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/EvalList.vue